import Slider from "../common/classes/slider.es6";

export default class Thumbnail {
    constructor() {
        this.init();
    }

    init() {
        this.setSwiper();
    }

    setSwiper() {
        const thumboption = {
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        };

        const swipersub = new Slider(".slider__sub", thumboption);
        const slides = [...document.querySelectorAll(".slider__sub .swiper-slide")];

        const option = {
            autoplay: slides.length > 1 ? { delay: 5000 } : false,
            loop: true,
            slidesPerView: 1,
            breakpoints: {
                834: { slidesPerView: 1 },
            },
            centeredSlides: true,
            thumbs: { swiper: swipersub.swiperInstance },
        };

        const swiper = new Slider(".thumbnail__cont", option);
    }
}
